import { CSSProperties, useEffect, useState } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { colorPalette } from 'shared/constants';
import Logger from 'shared/utils/Logger';
import styles from './avatar.module.scss';

type AvatarSize = 'small' | 'medium' | 'large';

export interface AvatarProps {
  src?: string;
  alt?: string;
  size?: AvatarSize;
  bgColor?: string;
  color?: string;
  className?: string;
  style?: CSSProperties;
}

const logger = Logger.create({ loggerName: 'Avatar' });

export function Avatar({
  src,
  alt = '',
  size = 'medium',
  bgColor = colorPalette.neutral5,
  color = colorPalette.neutral1,
  className,
  style,
}: AvatarProps) {
  const [imageFailed, setImageFailed] = useState(false);
  useEffect(() => {
    setImageFailed(false);
  }, [src]);

  const showImage = !!src && !imageFailed;

  return (
    <div
      className={classnames(styles.avatar, styles[size], showImage && styles.avatarImg, className)}
      style={{ background: bgColor, ...style }}>
      <span className={styles.avatarName} style={{ color }}>
        {alt ? alt : <FontAwesomeIcon icon={faUser} />}
      </span>
      {showImage && (
        <img
          className={styles.image}
          src={src}
          alt={alt}
          onError={() => {
            logger.warn('Failed to load avatar image', { src });
            setImageFailed(true);
          }}
        />
      )}
    </div>
  );
}
